import { Text } from 'native-base';
import { Ref } from 'react';
import { ModalInformation } from 'ui/components/ModalInformation';

interface ModalEmployeeIdNumberProps {
  modalRef: Ref<unknown> | undefined;
}

export const ModalEmployeeIdNumber = ({
  modalRef,
}: ModalEmployeeIdNumberProps) => {
  return (
    <ModalInformation headerText="Employee ID Number" modalRef={modalRef}>
      <Text mt={2} fontSize="md" color="gray.600">
        The Employee ID Number is a unique identification number assigned to
        each volunteer on the platform. This number acts as a seamless reference
        for organisations using an external volunteering management system.
        <br />
        <br />
        The Employee ID Number is visible both in the volunteer list and
        individual volunteer profiles. To associate or edit the Employee ID
        Number, access the field via the options button in the volunteer list or
        during the invitation process.
        <br />
        <br />
        Admins have the ability to enable or disable the Employee ID Number
        field within the Organisation Settings {'>'} General.
      </Text>
    </ModalInformation>
  );
};
